var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurveys2Selected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6002_16)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6002_16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 58.5,
    r: 33.5,
    fill: "#EA7506",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_6002_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0495 78.3142C25.1616 74.402 25.6408 70.459 25.851 66.897C25.907 65.9414 25.6268 65.224 25.0131 64.4953C21.2213 60.0058 17.5081 55.4546 14.4226 50.4354C13.5678 49.0482 12.7579 47.6274 12.2843 46.0524C11.6257 43.8609 12.0769 42.639 13.9994 41.4003C16.4936 39.7917 19.2764 38.8192 22.0537 37.8636C26.2489 36.4147 30.5255 35.2489 34.8413 34.2316C35.8389 33.9962 36.4779 33.5114 37.0048 32.6622C40.0594 27.7551 43.2346 22.9265 46.9507 18.479C47.9091 17.3328 48.932 16.2427 50.0866 15.2926C52.2137 13.5411 53.898 13.5691 55.955 15.3795C57.7121 16.9265 59.245 18.6808 60.6743 20.5276C63.4767 24.1428 66.0494 27.9177 68.4119 31.8271C69.2946 33.29 70.3372 34.1055 72.0383 34.4979C77.5423 35.7674 82.9706 37.3227 88.2056 39.4862C89.5004 40.0215 90.7699 40.6156 91.9385 41.3975C94.0151 42.7903 94.4159 43.9225 93.6228 46.2682C92.9614 48.2271 91.8852 49.9758 90.7671 51.6965C87.8889 56.1188 84.6101 60.244 81.1574 64.2263C80.1906 65.3417 80.0281 66.4318 80.1289 67.7966C80.6054 74.2955 80.9977 80.8028 80.0533 87.2989C79.4592 91.3877 78.4811 92.2453 74.3391 91.8837C69.7851 91.4886 65.5394 89.8407 61.2712 88.3442C58.8499 87.4951 56.4622 86.5507 54.0857 85.581C53.2842 85.2531 52.6144 85.2784 51.8213 85.5978C46.1548 87.893 40.449 90.0874 34.4657 91.4522C32.7366 91.8473 30.9963 92.122 29.1999 91.9454C27.8716 91.8165 27.0729 91.1299 26.6048 89.936C25.212 86.3993 24.9318 82.375 25.0495 78.3142Z",
    fill: "#EA7506"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.3829 52.025C47.3529 56.1736 44.1845 59.3865 40.1565 59.3521C36.0952 59.3143 32.9501 55.9672 33.0001 51.736C33.0501 47.6803 36.4217 44.2541 40.2731 44.3435C44.3644 44.4364 47.4129 47.7319 47.3829 52.025ZM40.2931 48.788C38.7006 48.7432 37.3313 50.0986 37.2813 51.7704C37.228 53.4904 38.4374 54.8561 40.0766 54.9283C41.7857 55.004 43.1983 53.6452 43.215 51.908C43.2316 50.2809 41.879 48.8327 40.2931 48.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.614 51.8563C58.6207 47.6217 61.8757 44.2574 65.8871 44.3434C69.8251 44.426 73.0002 47.804 72.9968 51.9079C72.9935 56.1047 69.7718 59.3795 65.6772 59.352C61.6958 59.3245 58.6074 56.0462 58.614 51.8563ZM68.7156 51.8047C68.679 50.1294 67.3297 48.7638 65.7371 48.7879C64.1579 48.8119 62.7886 50.2464 62.7819 51.8769C62.7786 53.6107 64.1779 54.9901 65.8871 54.9316C67.5296 54.8732 68.7523 53.5213 68.7156 51.8047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0436 65.1865C50.5915 65.1865 48.3526 65.8504 46.4269 67.4672C45.8005 67.9935 45.1542 68.3134 44.5645 67.5429C43.9715 66.7723 44.4712 66.1875 45.0409 65.6509C48.9256 61.9976 56.8883 61.9632 60.8897 65.5924C61.5027 66.1497 62.0957 66.762 61.3828 67.5979C60.7464 68.3444 60.1367 67.8972 59.5137 67.419C57.4081 65.8126 55.5523 65.1968 53.0436 65.1865Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0752 43.2212C35.6588 43.1937 35.2623 43.2143 34.8892 43.1283C34.4261 43.0217 34.0662 42.7018 34.0996 42.1754C34.1329 41.656 34.496 41.3189 34.9958 41.3499C37.8443 41.5356 40.1599 40.3695 42.1822 38.4087C42.6419 37.9649 43.165 37.7826 43.6181 38.3571C44.0679 38.9281 43.7447 39.4235 43.3083 39.8431C41.2526 41.8143 38.9005 43.0836 36.0752 43.2212Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9084 43.2184C67.1231 43.1117 64.7243 41.8149 62.642 39.7921C62.1922 39.3553 61.9457 38.8255 62.4354 38.2992C62.9252 37.7729 63.4349 38.0274 63.8847 38.4609C65.8637 40.3701 68.1292 41.5293 70.9212 41.3401C71.4209 41.3057 71.8241 41.5878 71.8974 42.0866C71.984 42.692 71.5842 43.0326 71.0411 43.1461C70.7146 43.2149 70.3748 43.1943 69.9084 43.2184Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2931 48.7862C41.8756 48.831 43.2316 50.2792 43.2149 51.9063C43.1983 53.6435 41.7857 55.0023 40.0765 54.9266C38.4373 54.8543 37.2279 53.4887 37.2812 51.7687C37.3345 50.0969 38.7039 48.7415 40.2931 48.7862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7157 51.8043C68.7523 53.5208 67.5263 54.8727 65.8871 54.9312C64.1813 54.9897 62.7787 53.6103 62.782 51.8765C62.7853 50.246 64.158 48.8115 65.7372 48.7874C67.333 48.7633 68.6824 50.129 68.7157 51.8043Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6002_16",
    x: -6,
    y: 0,
    width: 117,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "effect1_foregroundBlur_6002_16"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_6002_16",
    x: 4,
    y: 6,
    width: 98.0017,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6002_16"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6002_16",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.51 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6002_16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6002_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveys2Selected);
export default __webpack_public_path__ + "static/media/surveys2selected.cbb8e36994afb790cdf031e2b8b698dc.svg";
export { ForwardRef as ReactComponent };